import { render, staticRenderFns } from "./ThirdPartyDeliveryIndex.vue?vue&type=template&id=e7855f76"
import script from "./ThirdPartyDeliveryIndex.vue?vue&type=script&lang=js"
export * from "./ThirdPartyDeliveryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports